import { render, staticRenderFns } from "./SolarVillage.vue?vue&type=template&id=2f8c6c92&scoped=true&"
import script from "./SolarVillage.vue?vue&type=script&lang=ts&"
export * from "./SolarVillage.vue?vue&type=script&lang=ts&"
import style0 from "./SolarVillage.vue?vue&type=style&index=0&id=2f8c6c92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c6c92",
  null
  
)

export default component.exports